'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DropdownItem = DropdownItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropdownItem(props) {
    return _react2.default.createElement("li", { role: 'presentation' }, props.children);
}
//# sourceMappingURL=DropdownItem.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Dropdown/DropdownItem.js